interface BookingPoweredByProps {
  href?: string;
  enabled?: boolean;
  isDarkMode?: boolean;
}

const DEFAULT_HREF =
  'https://www.salescal.ai/?utm_source=powered_by&utm_medium=referral&utm_campaign=booking_form&utm_content=form_footer';

export function BookingPoweredBy({
  href,
  enabled = true,
  isDarkMode = false,
}: BookingPoweredByProps = {}) {
  if (!enabled) return null;

  return (
    <div
      className={`flex justify-center py-3 border-t ${
        isDarkMode ? 'border-gray-700 bg-gray-900' : 'border-gray-200 bg-white'
      }`}
    >
      <a
        href={href || DEFAULT_HREF}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-1.5 text-xs transition-opacity opacity-70 hover:opacity-100 ${
          isDarkMode ? 'text-gray-300' : 'text-gray-500'
        }`}
      >
        <span>Powered by</span>
        <img
          src={isDarkMode ? '/sc-logo-light.svg' : '/sc-logo.svg'}
          alt="SalesCal"
          className="h-[22px] w-auto"
        />
      </a>
    </div>
  );
}
